import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';

const InfoCard = ({ title, subheadline, description, expanded, onToggle }) => {
  return (
    <div className="info-card">
      <button 
        onClick={onToggle}
        className="w-full p-5 flex flex-col gap-3 text-left"
      >
        <div className="flex items-start justify-between">
          <div className="flex flex-col gap-2">
            <h3 className="text-lg font-serif" style={{ color: '#1a1a2e' }}>{title}</h3>
          </div>
          <div className="w-6 h-6 flex items-center justify-center" style={{ color: '#999' }}>
            {expanded ? <Minus className="w-5 h-5" /> : <Plus className="w-5 h-5" />}
          </div>
        </div>
        <p className="text-sm leading-relaxed" style={{ color: '#666' }}>
          {subheadline}
        </p>
      </button>
      
      {expanded && (
        <div className="px-5 pb-5 pt-0">
          <div className="pt-4" style={{ borderTop: '1px solid #eee' }}>
            <p className="text-sm leading-relaxed" style={{ color: '#555' }}>
              {description}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const Step5 = ({ data, onSelect, overrides }) => {
  const [expandedCard, setExpandedCard] = useState(null);

  const healthAreas = [
    {
      id: 'energy',
      title: 'Energy & Metabolism',
      subheadline: 'Supports mitochondrial energy production and metabolic efficiency.',
      description: 'Hashi-aid provides key thyroid-support nutrients that help your cells convert nutrients into usable energy. By supporting mitochondrial function and healthy thyroid hormone activity, Hashi-aid helps promote steady energy levels and a more efficient metabolism throughout the day.'
    },
    {
      id: 'hair',
      title: 'Hair, Skin & Nails',
      subheadline: 'Supports healthy keratin production and skin hydration.',
      description: 'Thyroid imbalance can affect hair growth, skin texture, and nail strength. Hashi-aid includes nutrients that support keratin formation and cellular turnover, helping maintain healthy hair, smoother skin, and stronger nails as thyroid balance improves.'
    },
    {
      id: 'hormonal',
      title: 'Hormonal Balance',
      subheadline: 'Supports optimal thyroid hormone conversion and utilization.',
      description: 'Hashi-aid is designed to support the body\'s natural ability to convert inactive thyroid hormone into its active form. By supporting key enzymatic processes involved in hormone conversion and utilization, Hashi-aid helps promote balanced thyroid function and whole-body hormonal support.'
    }
  ];

  const toggleCard = (cardId) => {
    setExpandedCard(expandedCard === cardId ? null : cardId);
  };

  return (
    <div className="flex flex-col">
      {/* Heading */}
      <h1 className="font-serif text-4xl md:text-5xl leading-tight mb-2" style={{ color: '#1a1a2e' }}>
        <span className="gradient-text">Hashi-aid</span> supports whole-body health.
      </h1>
      
      {/* Subtext */}
      <p className="text-base mb-8 leading-relaxed" style={{ color: '#666' }}>
        Formulated with clinically studied nutrients that support thyroid function, metabolism, and energy production.
      </p>

      {/* Info Cards */}
      <div className="flex flex-col gap-4">
        {healthAreas.map((area) => (
          <InfoCard
            key={area.id}
            title={area.title}
            subheadline={area.subheadline}
            description={area.description}
            expanded={expandedCard === area.id}
            onToggle={() => toggleCard(area.id)}
          />
        ))}
      </div>
    </div>
  );
};

export default Step5;
